import React from 'react';

const SectionHeader = ({
  title,
  titleLine2,
  subtitle,
  eyebrow,
  centered = true,
  className = '',
  titleClassName = '',
}) => (
  <div
    className={`rihen-section-head ${centered ? 'rihen-section-head--center' : ''} ${className}`.trim()}
    data-reveal
    data-reveal-head
  >
    {eyebrow ? <p className="rihen-section-head__eyebrow">{eyebrow}</p> : null}
    <h2 className={`rihen-section-head__title ${titleClassName}`.trim()}>
      {title}
      {titleLine2 ? <em>{titleLine2}</em> : null}
    </h2>
    {subtitle ? <p className="rihen-section-head__subtitle">{subtitle}</p> : null}
  </div>
);

export default SectionHeader;
